import { useLang } from '../i18n';
import * as en from '../mock';
import * as de from './de';
import { serviceDetails as enServiceDetails, serviceScopeIntro as enScopeIntro } from '../data/serviceDetails';

const enAll = { ...en, serviceDetails: enServiceDetails, serviceScopeIntro: enScopeIntro };
const deAll = { ...de };

// Returns language-resolved content. German values fall back to English when absent.
export const useContent = () => {
  const { lang } = useLang();
  const src = lang === 'de' ? deAll : {};
  return new Proxy({}, {
    get: (_, key) => (src[key] !== undefined ? src[key] : enAll[key])
  });
};
